let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aoPmK")).then(() => parcelRequire('7XuGk'));